import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import consola from 'consola';
import Seo from '~/components/functional/Seo/EditorialSeo.vue';
import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
import OpenGraph from '~/components/functional/OpenGraph/EditorialOpenGraph.vue';
import TcVars from '~/components/functional/TcVars/EditorialTcVars.vue';
import { PRISMIC_URL } from '~/const/3rd';
import { formatPrismicImage } from '~/helpers/image-helper';
import { componentList, typeDefinition, buildSlices } from '~/helpers/editorial-helper';
import { fetchContent } from '~/services/editorial';
const components = {};
componentList().forEach(e => {
  components[e.type || e.name] = slug => ({
    component: import("~/components/organisms/Editorial/".concat(slug))
  });
});
export default {
  validate(_ref) {
    let {
      params: {
        alias,
        slug
      }
    } = _ref;
    return alias && (slug || 'landing');
  },

  name: 'Article',
  components: {
    Seo,
    OpenGraph,
    TcVars,
    RatingJsonLd
  },
  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=3600, public'
  }),

  asyncData(_ref2) {
    return _asyncToGenerator(function* () {
      let {
        error,
        params: {
          alias,
          slug = 'landing'
        },
        app: {
          apolloProvider
        },
        store
      } = _ref2;

      try {
        const definition = typeDefinition(alias);
        const content = yield fetchContent(store, {
          type: definition.type,
          slug,
          alias
        });

        if (!content.results.length) {
          error({
            statusCode: 404,
            message: 'Not Found'
          });
          return false;
        }

        const {
          results: [{
            id,
            data,
            tags
          }]
        } = content;

        if (data.alias && data.alias !== alias) {
          error({
            statusCode: 404,
            message: 'Not Found'
          });
          return false;
        }

        const slices = yield buildSlices(definition, data, apolloProvider.defaultClient, store);
        const {
          event_category: eventCategory,
          event_action: eventAction,
          event_label: eventLabel
        } = data;
        const tracking = {
          eventCategory,
          eventAction,
          eventLabel
        };
        return {
          type: definition.type,
          template: {
            path: definition.path,
            data,
            tracking
          },
          id,
          tags,
          slices
        };
      } catch (e) {
        error({
          statusCode: 404,
          message: 'Not Found'
        });
        consola.error(e); // this is undefined in catch
        // if (this.$sentry) {
        //   this.$sentry.captureException(e);
        // }
      }

      return false;
    })();
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    tcVars() {
      return this.template ? _objectSpread({}, this.template.data, {
        env_template: this.template.data.env_template || 'Landing Page'
      }) : {};
    }

  }),

  created() {
    if (this.template.path) {
      this[this.type] = () => components[this.type](this.template.path);
    }

    this.slices.forEach((_ref3) => {
      let {
        type,
        path
      } = _ref3;

      this[type] = () => components[type](path);
    });
  },

  beforeMount() {
    const prismicEdit = this.$cookies.get('editor');

    if (prismicEdit) {
      window.prismic = {
        endpoint: this.$store.state.sharedEnv.payload.prismic
      };
      this.asyncScript(PRISMIC_URL).then(() => {}).catch(err => {
        consola.error('PRISMIC FAILED', err);
      });
    }
  },

  methods: {
    currentComponent(arg) {
      return this[arg];
    },

    options(_ref4) {
      let {
        global_background_color: backgroundColor,
        global_background_image: image
      } = _ref4;
      return process.browser ? _objectSpread({}, backgroundColor && {
        style: {
          backgroundColor
        }
      }, image && image.url && {
        'data-bgset': formatPrismicImage(image.url),
        class: 'lazyload bg-center'
      }) : null;
    }

  }
};